export enum DenialRationaleTemplatesEnum {
  DenialRationalePilot = 'Denial Rationale Pilot',
  LackOfPhysicianOrders = 'Lack of Physician Orders'
}

export const OptionalRationaleTemplates = new Set<string>([
  'PT-100 - PT Full Denial No Info After Multiple Attempts',
  'OT-100 - OT Full Denial No Info After Multiple Attempts',
  'SN-100 - SN Full Denial No Info After Multiple Attempts',
  'ST-100 - ST Full Denial No Info After Multiple Attempts',
  'MSW-100 - MSW Full Denial No Info After Multiple Attempts',
  'HHA-100- HHA Full Denial No Info After Multiple Attempts'
]);
